import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import HomePage from "../containers/HomePage";
import NigokiPage from "../containers/NigokiPage";
import Capture from "../containers/Capture";
import CaptureTest from "../containers/CaptureTest";
import LoginPage from "../containers/LoginPage";
import ModerationPage from "../containers/ModerationPage";
import ThankYou from "../components/ThankYou";
import RSVPThankYou from "../containers/RSVPThankYou";
import { PrivateRoute } from '../components/PrivateRoute';

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <div>
          {/* <PrivateRoute exact path="/" component={HomePage} /> */}
          <Route exact path="/" component={HomePage} />
          <Route exact path="/nigoki" component={NigokiPage} />
          <Route path="/capture" component={Capture} />
          <Route path="/capture-test" component={CaptureTest} />
          <Route path="/nigoki/thank-you" component={ThankYou} />
          <Route path="/thank-you" component={RSVPThankYou} />
          <Route path="/login" component={LoginPage} />
          <PrivateRoute path="/moderation" component={ModerationPage} />
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js